<template>
  <div class="tos page">
    <h1>Terms and Conditions</h1>

    <h3>Terms</h3>

    <p>By accessing this web site and/or using the PingZapper service, you are agreeing to be bound by these web site Terms and Conditions of Use, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site and its services. The materials contained in this web site are protected by applicable copyright and trade mark law.</p>

    <h3>Pricing</h3>
    <p>All prices denoted by ($) on the PingZapper website are in USD.</p>
    <p>Service pricing are subject to change at any time. PingZapper will announce the service price change at least 14 days in advance.</p>

    <h3>Delivery</h3>
    <p>Once a subscription has been activated, your account should be activated immediately.</p>

    <h3>Cancellations</h3>
    <p>You may cancel your PingZapper subscription at any time by <NuxtLinkLocale href="/subscription">managing your subscription</NuxtLinkLocale>.</p>
    <p>If you have any time left in your current billing cycle, you may continue to use PingZapper until the subscription end date.</p>

    <h3>Refunds</h3>
    <p>PingZapper offers a 14-day money back guarantee. If you are unsatisfied with PingZapper in any way, you can contact <NuxtLinkLocale href="/support">support</NuxtLinkLocale> to apply for a refund within 14 days of initial payment.</p>

    <h3>Usage</h3>
    <ul>
      <li>Use of PingZapper servers are limited to gameplay data. This means you may not use them for:
        <ul>
          <li>Any malicious and/or illegal activities</li>
          <li>As a general proxy server(e.g. web browsing, download, IRC)</li>
          <li>Downloading / accessing pirated data</li>
        </ul>
      </li>
      <li>Share your user details to anyone</li>
      <li>Your account with PingZapper shall automatically terminate if you violate any of these restrictions and may be terminated by PingZapper at any time. PingZapper also reserves the right to close your account at any time without any notice or reason for doing so.</li>
    </ul>

    <h3>Account</h3>
    <p>You may not share your PingZapper account with another person. Multiboxers are allowed up to two unique logins from the same IP address.</p>

    <h3>Limitations</h3>
    <p>In no event shall PingZapper or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption,) arising out of the use or inability to use any of the services PingZapper provides, even if PingZapper or a PingZapper authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.</p>

    <h3>Revisions and Errata</h3>
    <p>The materials appearing on PingZapper's web site could include technical, typographical, or photographic errors. PingZapper does not warrant that any of the materials on its web site are accurate, complete, or current. PingZapper may make changes to the materials contained on its web site at any time without notice. PingZapper does not, however, make any commitment to update the materials.</p>

    <h3>Links</h3>
    <p>PingZapper has not reviewed all of the sites linked to its Internet web site and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by PingZapper of the site. Use of any such linked web site is at the user's own risk.</p>

    <h3>Terms of Use Modifications</h3>
    <p>PingZapper may revise these terms of use at any time without notice. By using the PingZapper website or the PingZapper service you are agreeing to be bound by the then current version of these Terms and Conditions of Use.</p>
  </div>
</template>
